import { render, staticRenderFns } from "./TopicListing.vue?vue&type=template&id=c010b0d2&"
import script from "./TopicListing.vue?vue&type=script&lang=js&"
export * from "./TopicListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports